export class ApplicationEventModel {
    applicationId: number;
    notes: string;
    source: string = 'System';
    type: string = 'event';
}
